import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Reactathon 2018 was a hoot ❤️",
  "description": "",
  "published": "2018-03-22T00:00:00.000Z",
  "redirect_from": ["/blog/reactathon-2018-hoot-%e2%9d%a4%ef%b8%8f/swizec/8293"],
  "categories": "Personal, Travel + Events",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <lite-youtube {...{
      "videoid": "RO8PtE4jM5k",
      "videostartat": "0"
    }}></lite-youtube>
    <p>{`Reactathon 2018 was a hoot. Met a bunch of great people, saw some great talks, gave a 7 hour workshop, and a 20 minute talk. Both on `}<a parentName="p" {...{
        "href": "https://swizec.com/reactd3js"
      }}>{`React + D3`}</a>{`.`}</p>
    <p>{`🤘`}</p>
    <p>{`I'm missing Day 2 of the advanced conf and 2 days of the hackathon because gotta get back to work. Don't think I could make it anyway. It's been an intense week and a half.`}</p>
    <p>{`Turns out it's not a good idea to be bad at calendars. 😅`}</p>
    <p><strong parentName="p">{`BUT`}</strong>{` I prepped a workshop in a week of nights and mornings, made a great talk in four hours the night before, and nobody even noticed. Someone even said they `}<em parentName="p">{`"Loved how well prepared you were"`}</em>{` for the workshop.`}</p>
    <p>{`And my talk was described as `}<em parentName="p">{`"Very charismatic"`}</em>{` and `}<em parentName="p">{`"Went great"`}</em></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2018/03/rock-on.gif",
        "alt": null
      }}></img></p>
    <p>{`Rock on`}</p>
    <p>{`You can see my slides here 👉 `}<a parentName="p" {...{
        "href": "https://react-d3-reactathon.now.sh/"
      }}>{`https://react-d3-reactathon.now.sh/`}</a>{` but they're better with jokes. Reactathon is publishing professional video some time soon. I'm not sure when.`}</p>
    <p>{`This is the most important slide. It comes last 👇`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2018/03/react-d3-love.png",
        "alt": null
      }}></img></p>
    <p>{`React+D3 = ❤️`}</p>
    <p>{`Reactathon itself was great too. Talked to the founder of `}<a parentName="p" {...{
        "href": "http://netlify.com/"
      }}>{`Netlify`}</a>{`, the founder of `}<a parentName="p" {...{
        "href": "http://gatsbyjs.org"
      }}>{`Gatsby`}</a>{`, the founder of `}<a parentName="p" {...{
        "href": "https://www.graph.cool/"
      }}>{`GraphCool`}</a>{`, the team of `}<a parentName="p" {...{
        "href": "https://hasura.io/"
      }}>{`Hasura`}</a>{`, and some folks at `}<a parentName="p" {...{
        "href": "https://www.flexport.com/"
      }}>{`Flexport`}</a>{`. They had a cool dataviz at their table. Yes I talked to not-founders too, but I can't remember all the companies they worked for.`}</p>
    <p>{`I did chat to a team from Tile. Asked for a way to contact the person who finds my lost keys. They nodded politely, said it was an interesting idea, and thought I was an idiot.`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Ok I’m sold, I need to get on the GraphQL train `}<a parentName="p" {...{
          "href": "https://twitter.com/hashtag/reactathon?src=hash&ref_src=twsrc%5Etfw"
        }}>{`#reactathon`}</a>{` `}<a parentName="p" {...{
          "href": "https://t.co/5p4SBlpe1H"
        }}>{`pic.twitter.com/5p4SBlpe1H`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/976561136383410176"
      }}>{`March 21, 2018`}</a></blockquote>
    <p>{`GraphQL definitely looks like the future. Either using GraphCool, or their new thing Prisma, or Hasura, or something completely different. I have got to get on the GraphQL train. Startups are building tools that make it easy to adopt, no need to write backend code anymore. Which is exactly what I don't want to do 👌`}</p>
    <p>{`I also enjoyed Kyle Matthews' point that React sites should be deployed as static by default. Gatsby isn't so much a framework as it is a compile step in your toolchain and that makes so much sense. Never thought of it that way before.`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`I didn’t get any cool slide pics but I liked this insight:`}<br parentName="p"></br><br parentName="p"></br>{`1. Measure`}<br parentName="p"></br>{`2. Fix low hanging fruit`}<br parentName="p"></br>{`3. Verify`}<br parentName="p"></br>{`4. Find next fruit`}<br parentName="p"></br><br parentName="p"></br>{`Or if you’re a normal person, let `}<a parentName="p" {...{
          "href": "https://twitter.com/kylemathews"
        }}>{`@kylemathews`}</a>{` and his Gatsby team do all that and focus on your fun problems. `}<a parentName="p" {...{
          "href": "https://twitter.com/hashtag/reactathon?src=hash&ref_src=twsrc%5Etfw"
        }}>{`#reactathon`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/976601418839744513"
      }}>{`March 21, 2018`}</a></blockquote>
    <p>{`Besides, why would you want to deal with performance optimization, if there's a whole team of people dedicated to making your site faster for you?`}</p>
    <p>{`Oh and WebAssembly. Smells like the future, wags its pointy little finger at the future, still doesn't seem to quite be here for us to use quite just yet. Looks exciting tho. JavaScript compiled down to byte code running directly on the browser VM without parsing? Yes!`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`WebAssembly - byte code for the web, the cool new thing by `}<a parentName="p" {...{
          "href": "https://twitter.com/_jayphelps"
        }}>{`@_jayphelps`}</a>{` `}<br parentName="p"></br><br parentName="p"></br>{`Solves the problem of parse times being slower than network times 😱`}<a parentName="p" {...{
          "href": "https://twitter.com/hashtag/reactathon?src=hash&ref_src=twsrc%5Etfw"
        }}>{`#reactathon`}</a>{` `}<a parentName="p" {...{
          "href": "https://t.co/KeOpLXSUqh"
        }}>{`pic.twitter.com/KeOpLXSUqh`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/976517985702563840"
      }}>{`March 21, 2018`}</a></blockquote>
    <p>{`There was also a great talk by Erica Cooksey about sharing code between React Native and real native. It went way over my head, but I love it when first time speakers present and completely crush it.`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Learning all about talking between native code and react native code from `}<a parentName="p" {...{
          "href": "https://twitter.com/EricaCooksey"
        }}>{`@ericacooksey`}</a>{` `}<a parentName="p" {...{
          "href": "https://twitter.com/hashtag/reactathon?src=hash&ref_src=twsrc%5Etfw"
        }}>{`#reactathon`}</a>{` `}<a parentName="p" {...{
          "href": "https://t.co/QfAsU9q2Bw"
        }}>{`pic.twitter.com/QfAsU9q2Bw`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/976553676507512832"
      }}>{`March 21, 2018`}</a></blockquote>
    <p>{`And I love that Reactathon had first time speakers despite being a big conference. Fresh faces are important. Nobody wants to keep seeing the same 10 people present at every conference.`}</p>
    <p>{`Wish I went to the blockchain talk. Chatted with the dude giving it, talked him out of livecoding too much, and he seemed like an interesting dude and the blockchain stuff sounded cool, but I was chatting with Hasura about wrapping PostgreSQL in GraphQL instead.`}</p>
    <p>{`Heh.`}</p>
    <p>{`Solid 7/7 conference, would stress about presenting at again`}</p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/swizec"
      }}>{`Comment at me on twitter 🤙`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      